module.exports = __webpack_public_path__ + "img/evaluate.8f6d6b87.png";